import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import PropTypes from 'prop-types';
import { authHeaders } from 'actions';

function PartnerCustomTagField({ kind, label }) {
  const { control, formState: { errors } } = useFormContext();
  const { data: partnerCustomTags, isLoading } = useQuery({
    queryKey: ['administration', 'organization', 'partnerCustomTags', kind],
    queryFn: () => axios.get(Routes.api_dashboard_partner_custom_tags_path({kind: kind}), { headers: authHeaders() }),
  });

  return (
    <>
      <span className='u-txt--label'>{label}</span><br />
      <Controller
        name='partner_custom_tag_association'
        control={control}
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              isLoading={isLoading}
              isClearable
              name='sp-group-select'
              className={clsx('o-select o-select--optgroup', { 'o-select--error': errors.partner_custom_tag_association })}
              value={isLoading || !value ? null : partnerCustomTags.data.find((tag) => tag.id === value.partner_custom_tag_id)}
              getOptionValue={(option) => option.id}
              onChange={(v) => {
                if (v) {
                  onChange({
                    partner_custom_tag_id: v.id,
                  });
                } else {
                  onChange({
                    _destroy: true,
                  });
                }
              }}
              options={isLoading ? [] : partnerCustomTags.data}
            />
          </>
        )}
      />
      {errors.partner_custom_tag_association && (<p className='u-txt--error'>{errors.partner_custom_tag_association.message}</p>)}
    </>
  )
}

PartnerCustomTagField.propTypes = {
  kind: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default PartnerCustomTagField;
